import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as action from "../pagoDeducibleAuto-actions";
import "../pago-deducible.css";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import Card from "@material-ui/core/Card";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Button from "@material-ui/core/Button";
import visa from "../../img/visa-card.png";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import LinearProgress from "@material-ui/core/LinearProgress";
import ReceiptIcon from "@material-ui/icons/Receipt";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ModalError from "../modal-error/modal-error.cmpt";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {downloadPDF, errorCampoRequerido,formatFchExpire} from "../utils";
import PagoVentanilla from "./pagoVentanilla.cmpt";
import PagoEnLinea from "./pagoLinea.cmpt";
import {handleChanges, handlePattern,handleCloseRegresar,
	erroresPago,actionPagoBancario,errorGenCard,errorElseBlur, 
	errorFchVencimiento,handleCloseErrorPago,handleOptionsCfdi,
	closeIconCvvs,handleCorreoNotificarComprobantes,iconCloseDetalles, 
	handleCloseNotificaciones,setDataLinea
} from "./utils";

const initStateResponsePago = {
	message: "",
	authorizationCode: "",
	monto: "",
	banco: "",
	codSiniestro: "",
	poliza: "",
	nombreTitular: "",
	numReferencia: "",
	numTarjeta: "",
	idPago: null,
	fechaPago: "",
	fchVigenciaInicial: "",
	fchVigenciaFinal: "",
	pdfComprobante: "",
	vehiculo: {
		vin: "",
		marcaVehiculo: "",
		tipoVehiculo: "",
		modelo: "",
		placas: "",
		descripcion: "",
	},
};
const borderInput = "1px solid #AAC3EE";
const borderBox = "border-box";
const borderCard = "1px solid #DBE4F0";
const boxCard = "0px 4px 16px rgba(0, 63, 138, 0.22)";
const sizeImportant = "8px !important";
const useStyles = makeStyles((theme) => ({
	inputStyles: {
		"& .MuiInputBase-input": {
			paddingBottom: "0px",
			paddingTop: "0px",
			marginBottom: "16px",
			pattern: (props) => props.pattern,
		},"& label": {
			color: "#33445F",
			fontSize: "16px",
		},"& label.Mui-focused": {
			color: "#647085",
		},"& .MuiInput-underline:after": {
			borderBottom: borderInput,
		},"& .MuiInput-underline:before": {
			borderBottom: borderInput,
		},"& .MuiInput-underline": {
			borderColor: "#AAC3EE",
			fontSize: "16px",
			color: "#0C2040",
		},"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			borderBottom: "1px solid #FFB022",
		},"& .MuiInput-underline:hover:not(.Mui-disabled):after": {
			borderBottom: borderInput,
		},"& .MuiTypography-body1": {
			fontSize: "16px",
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: 400,
		},"& .MuiFormHelperText-root.Mui-error": {
			fontSize: "12px",
			color: "#CD5A59",
		},"& .MuiFormLabel-root.Mui-error": {
			color: "#CD5A59",
		},
	},
	borderGrid: {
		borderRight: "1px solid #CED8E8",
		paddingLeft: "16px",
		paddingRight: "24px",
		paddingTop: "22px",
		paddingBottom: "32px",
	},
	cardPago: {
		background: "#FFFFFF",
		border: borderCard,
		boxSizing: borderBox,
		boxShadow: boxCard,
		borderRadius: "5px",
		width: "100%",
	},
	colorEstadoPago: {
		color: "#FF9048 !important",
		width: sizeImportant,
		height: sizeImportant,
		marginRight: "8px",
	},
	colorEstadoDetalle: {
		color: "#5BC790 !important",
		width: sizeImportant,
		height: sizeImportant,
		marginRight: "8px",
	},
	cardPagoVentanilla: {
		background: "#FFFFFF",
		border: borderCard,
		boxSizing: borderBox,
		boxShadow: boxCard,
		borderRadius: "5px",
		width: "100%",
	},
	modalBodyCvv: {
		maxWidth: "412px",
		padding: "32px 32px 0px 32px",
		textAlign: "center",
	},
	modalBodyProcesando: {
		maxWidth: "463px",
		padding:"32px"
	},
	modalDetalleRecibo: {
		maxHeight: "588px",
		position: "initial",
	},
	modalDetalleReciboPaper: {
		"& .MuiDialog-paper": {
			width:"728px",
			overflow: "hidden"
		}
	},
	borderTopGrid: {
		borderTop: "1px solid #CED8E8",
		paddingTop: "7px",
	},
	margingIcon: {
		marginRight: "8px",
		marginBottom: "-2px",
		width: "18px",
		height: "18px",
	},
	footerModalCvv: {
		borderTop: "1px solid #E8EEF8",
		justifyContent: "flex-start",
		paddingBottom: "16px",
		paddingLeft: "24px",
		paddingTop: "16px",
	},
	centerTextfield: {
		justifyContent: "flex-start",
	},
	textFieldModalCvv: {
		width: "88px",
		marginBottom: "44px",
		"& .MuiFormHelperText-root.Mui-error":{
			width:"120%"
		},"& .MuiInputBase-input":{
			textAlign:"center"
		},"& label": {
			marginLeft:"30px"
		}
	},
	lineProgress: {
		width: "70%",
		marginLeft: "15%",
		"& .MuiLinearProgress-colorPrimary":{
			backgroundColor: "#CED8E8"
		},"& .MuiLinearProgress-barColorPrimary":{
			backgroundColor: "#FF6B0B"
		}
	},
	comprobantePendiente: {
		backgroundColor: "#EAF0FB",
		marginBottom: "32px",
		marginTop: "8px",
		padding: "0px"
	}
}));

const modalErroresPago = (openModales,datosModal,handleCloseErroresPago) => {
	return  <ModalError
		iconButton={true}
		openModal={openModales.modalErroresPago}
		msjTitle={datosModal.msjTitle}
		msjBody={datosModal.msjBody}
		msjBody2={datosModal.msjBody2}
		withButton={datosModal.withButton}
		handleClose={handleCloseErroresPago}
	/>;
};

const modalNotificacionCorreo = (openModales,datosModal,handleCloseNotificacion) => {
	return <ModalError
		iconButton={true}
		openModal={openModales.modalNotificacion}
		msjTitle={datosModal.msjTitle}
		msjBody={datosModal.msjBody}
		handleClose={(e) => handleCloseNotificacion(e)}
	/>;
};

const modalErrorPago = (openModales,datosModal,setOpenModales,handleCloseCvv) => {
	return  <ModalError
		iconButton={true}
		openModal={openModales.modalErrorPago}
		msjTitle={datosModal.msjTitle}
		msjBody={datosModal.msjBody}
		msjBody2={datosModal.msjBody2}
		withButton={datosModal.withButton}
		handleClose={(e) => handleCloseErrorPago(e,setOpenModales,handleCloseCvv,openModales)}
	/>;
};

const modalProceso = (openModales,classes,progress) => {
	return <Dialog
		disableEscapeKeyDown={true}
		disableBackdropClick
		open={openModales.modalProceso}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogContent className={classes.modalBodyProcesando}>
            
			<p className="pModalProceso">Estamos procesando tu pago</p>
			<p className="pModalProcesoSecond">
      En breve podrás visualizar tu recibo
			</p>
			<div className={classes.lineProgress}>
				<LinearProgress variant="determinate" value={progress} />
			</div>
		</DialogContent>
	</Dialog>;
};

const modalRegresar = (openModales, setOpenModales,props) => {
	return <ModalError
		iconButton={true}
		openModal={openModales.modalRegresar}
		msjTitle="Cancelar operación"
		msjBody="¿Desea cancelar la operación?"
		withButtons={{
			actionButtons: true,
			msjButton1:"No, volver",
			msjButton2:"Si, cancelar"
		}}
		handleClose={(e) => handleCloseRegresar(e,setOpenModales,openModales,props.handleRegresar)}
	/>;
};

const regresar = (setOpenModales,openModales) => {
	return   <button className="buttonRegresarPago" onClick={() => setOpenModales({...openModales,modalRegresar:true})}>
		<a className="hooverRegresarPago" style={{ margin: "0px", display: "inline-block" }}>
			<ArrowBackIcon
				style={{
					marginRight: "8px",
					width: "18px",
					height: "18px",
					marginBottom: "-3px",
				}}
			></ArrowBackIcon>
			<span className="butRegresar">Regresar</span>
		</a>
	</button>;
};

const modalDetalleRecibo = (varState,methods) => {
	return <Dialog
		maxWidth={"md"}
		className={varState.classes.modalDetalleReciboPaper}
		disableEscapeKeyDown={true}
		disableBackdropClick
		open={varState.openModales.modalDetalle}
		onClose={methods.handleCloseDetalle}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogContent className={varState.classes.modalDetalleRecibo}>
			<IconButton
				onClick={methods.iconCloseDetalle}
				style={{
					color: "#FF6B0B",
					position: "fixed",
					marginTop: "-30px",
					marginLeft: "675px",
					backgroundColor: "#FEFEFE",
					border: "1px solid #A3AAB6",
					height: "36px",
					width: "36px",
				}}
			>
				<CloseOutlinedIcon
					style={{ width: "22px", height: "22px" }}
				></CloseOutlinedIcon>
			</IconButton>
			<p className="p700">
				<ReceiptIcon></ReceiptIcon> Detalle del recibo
			</p>
			<p className="pSolicitudVentanilla">Total de pago:</p>
			<p className="pCantidadModal">$ {parseFloat(varState.datosPagoDeducibleAuto.totalPago).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
			<p className="pDetalleConfirmacionPagado">
				<FiberManualRecordIcon
					className={varState.classes.colorEstadoDetalle}
				></FiberManualRecordIcon>
          Pagado
			</p>
			<p className="pDetalleConfirmacion">Número de autorización bancaria</p>
			<p className="p700">{varState.responsePago.authorizationCode}</p>
			<Grid container spacing={1}>
				<Grid item container xs={12} sm={12} md={6} lg={6}>
					<Grid item className={varState.classes.borderTopGrid} xs={12}>
						<p className="pDetallePagoTitle">DATOS DE PAGO</p>
						<p className="pDetallePago">
                Titular de la tarjeta:{" "}
							<span className="pDetalleDatos">
								{varState.responsePago.nombreTitular}
							</span>{" "}
						</p>
						<p className="pDetallePago">
                Tarjeta:{" "}
							<span className="pDetalleDatos">
								{varState.responsePago.banco}{" "}{varState.responsePago.tipoPago}{" "}****{" "}{varState.responsePago.numTarjeta}
							</span>
						</p>
						<p className="pDetallePago">
                Fecha de pago:{" "}
							<span className="pDetalleDatos">{varState.responsePago.fechaPago}</span>
						</p>
					</Grid>
				</Grid>
				<Grid item container xs={12} sm={12} md={6} lg={6}>
					<Grid className={varState.classes.borderTopGrid} item xs={12}>
						<p className="pDetallePagoTitle">DATOS DE POLIZA</p>
						<p className="pDetallePago">
                No. Póliza:{" "}
							<span className="pDetalleDatos">
								{varState.datosPagoDeducibleAuto.numPoliza}
							</span>
						</p>
						<p className="pDetallePago">
                No. Siniestro:{" "}
							<span className="pDetalleDatos">
								{varState.datosPagoDeducibleAuto.codSiniestroPadre}
							</span>
						</p>
					</Grid>
				</Grid>
			</Grid>
			<Grid container spacing={1}>
				{
					varState.responsePago.idPago === null
						?
						<Grid className={varState.classes.comprobantePendiente} container item xs={12} sm={12} md={12} lg={12}>
							<p className="pComprobantePen">Tu comprobante de pago está en proceso, podrás consultarlo dentro 
                            de 48 horas hábiles a través de tu Portal y App Soy Cliente GNP.</p>
						</Grid>
						:
						<Grid container item xs={12} sm={12} md={12} lg={12}>
							<Grid item xs={12} sm={12} md={4} lg={4}style={{ marginBottom: "8px" }}>
								<button className="buttonIconRecibos" onClick={methods.handleOptionCfdi}>
									<a className="hooverLinkPagos">
										<InsertDriveFileOutlinedIcon
											className={varState.classes.margingIcon}
										></InsertDriveFileOutlinedIcon>
                                        Solicitar CFDI
									</a>
								</button>
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} style={{ marginBottom: "8px" }}>
								<button className="buttonIconRecibos" onClick={methods.handleCorreoNotificarComprobante}>
									<a className="hooverLinkPagos">
										<MailOutlineOutlinedIcon
											className={varState.classes.margingIcon}
										></MailOutlineOutlinedIcon>
                                        Enviar por correo
									</a>
								</button>
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} style={{ marginBottom: "8px" }}>
								<button className="buttonIconRecibos" onClick={methods.handleDescargaComprobante}>
									<a className="hooverLinkPagos">
										<GetAppOutlinedIcon
											className={varState.classes.margingIcon}
										></GetAppOutlinedIcon>
                                        Descargar comprobante
									</a>
								</button>
							</Grid>
						</Grid>
				}
			</Grid>
		</DialogContent>
	</Dialog>;
};

const detallesPago = (datosPagoDeducibleAuto,classes,handleOpen,disabledPagar,pagoVentanilla) => {
	return <Grid item xs={12} sm={12} md={4} lg={4} style={{paddingTop: "24px",paddingLeft: "16px",paddingRight: "16px",}}>
		<p className="pTitleDetallePago">
			<LibraryBooksOutlinedIcon className="sizeIcon"></LibraryBooksOutlinedIcon>{" "}
                Detalles del pago
		</p>
		<p className="pTitleDetalleTotal">Total a pagar :</p>
		<p className="pCantidad">$ {parseFloat(datosPagoDeducibleAuto.totalPago).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
		<p className="estadoPago">
			<FiberManualRecordIcon
				className={classes.colorEstadoPago}
			></FiberManualRecordIcon>
			{datosPagoDeducibleAuto.tramoStatus}
		</p>
		{pagoVentanilla === "linea" && (
			<div>
				<Button
					className="buttonRealizarPago"
					onClick={handleOpen}
					disabled = {disabledPagar()}
				>
                    Realizar pago
				</Button>
			</div>
		)}
		<Grid container>
			<Grid item xs={12} sm={12} md={4} lg={3}>
				<p className="pDatosPago">No. Póliza:</p>
			</Grid>
			<Grid item xs={12} sm={12} md={8} lg={9}>
				<p className="pDetalleDatosPagpo">
					{datosPagoDeducibleAuto.numPoliza}
				</p>
			</Grid>
		</Grid>
		<Grid container>
			<Grid item xs={12} sm={12} md={5} lg={4}>
				<p className="pDatosPago">No. Siniestro:</p>
			</Grid>
			<Grid item xs={12} sm={12} md={7} lg={8}>
				<p className="pDetalleDatosPagpo">
					{datosPagoDeducibleAuto.codSiniestroPadre}
				</p>
			</Grid>
		</Grid>
	</Grid>;
};

const modalCvv = (varState,methods) => {
	return <Dialog
		disableEscapeKeyDown={true}
		disableBackdropClick
		className={varState.classes.inputStyles}
		open={varState.openModales.modalCvv}
		onClose={methods.handleCloseCvv}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogContent className={varState.classes.modalBodyCvv}>
			<IconButton
				onClick={methods.closeIconCvv}
				style={{
					color: "#FF6B0B",
					position: "fixed",
					marginTop: "-30px",
					marginLeft: "180px",
					backgroundColor: "#FEFEFE",
					border: "1px solid #A3AAB6",
					height: "36px",
					width: "36px",
				}}
			>
				<CloseOutlinedIcon
					style={{ width: "22px", height: "22px" }}
				></CloseOutlinedIcon>
			</IconButton>
			<p className="pTitleModalCvv"> Código de seguridad ( CVV )</p>
			<p className="pModalCvv">
          Por seguridad, ingresa los 3 o 4 dígitos del código de seguridad (CVV)
          del reverso de tu tarjeta.
			</p>
			<p className="pCvvTarjeta">
				<img src={varState.tipoTarjeta}
					style={{
						marginRight: "8px",
						display: "inline-block",
						width: "40px",
						height: "24px",
					}}
				/>
          Tarjeta {varState.banco} ****
				{varState.maskAmex? 
					varState.tarjetaTemp.slice(varState.longCard - 5, varState.longCard - 1)
					: varState.tarjetaTemp.slice(varState.longCard - 7, varState.longCard - 1)}
			</p>
			<div className={varState.classes.centerTextfield}>
				<TextField
					onFocus={clickInput}
					onClick={clickInput}
					onPaste={(e)=>{
						e.preventDefault();
						return false;
					}} 
					onCopy={(e)=>{
						e.preventDefault();
						return false;
					}}
					autoComplete="off"
					helperText={errorCampoRequerido(varState.errorForm.codigoCvv)}
					error={varState.errorForm.codigoCvv}
					onBlur={methods.blurInput}
					onChange={methods.handleChange}
					className={varState.classes.textFieldModalCvv}
					type="text"
					id="codigoCvv"
					label="CVV"
					value={varState.creditCardPago.codigoCvv}
					name="codigoCvv"
				/>
			</div>
		</DialogContent>
		<DialogActions className={varState.classes.footerModalCvv}>
			<Button
				disabled={varState.creditCardPago.codigoCvv.length < varState.sizeCvv}
				className="buttonConfirmarPago"
				onClick={methods.handleCloseCvv}
			>
          Confirmar
			</Button>
		</DialogActions>
	</Dialog>;
};

const clickInput = (event) => {
	if(event.target.value){
		var myElement = document.getElementById(event.target.name);
		myElement.selectionStart = event.target.value.length;
		myElement.selectionEnd = event.target.value.length;
	}
};

const TipoPagoCfdi = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const dataSeguimiento = useSelector((state) => state.pagoDeducibleAutos.pagoDeducibleAutos);
	const getDetallePago = useSelector((state) => state.pagoDeducibleAutos.getDetallePago);
	const global = useSelector((state) => state.global);
	const disButPago = useSelector((state) => state.pagoDeducibleAutos.buttonPago);
	const [pagoVentanilla, setPagoVentanilla] = useState("");
	const [openModales, setOpenModales] = useState({
		modalCvv: false,
		modalProceso: false,
		modalDetalle: false,
		modalNotificacion: false,
		modalErrorPago: false,
		modalErroresPago: false,
		modalRegresar: false
	});
	const [responsePago, setResponsePAgo] = useState(initStateResponsePago);
	const [creditCardPago, setCreditCardPago] = useState({
		nombreTitular: "",
		numeroTarjeta: "",
		fchVencimiento: "",
		aceptarCargo: false,
		codigoCvv: "",
	});
	const [errorForm, setForm] = useState({
		codigoCvv: false,
		nombreTitular: false,
		numeroTarjeta: false,
		banco: false,
		fchVencimiento: false,
		invalidFchVencimiento: false,
		invalidCard: false,
	});
	const [datosPagoDeducibleAuto, setDatosPago] = useState({
		codSiniestroPadre: "",
		codSiniestro: "",
		numPoliza: "",
		tramoStatus: "",
		numReferencia: "",
		totalPago: "",
		authorizationCode: "",
	});
	const [datosReferenciaBancaria, setDatosReferenciaBancaria] = useState({
		nombreDocumento: "",
		urlVisualizacion: "",
		base64: ""
	});
	const [datosModal, setDatosModal] = useState({
		msjTitle: "",
		msjBody: "",
		msjBody2: "",
		withButton: {
			actionButton: true,
			msjButton1: "",
		},
		tipo: "",
	});
	const [tarjetaTemp,setTarjetaTemp] = useState("");
	const anoActual = 0;
	const [tipoTarjeta, setTipoTarjeta] = useState(visa);
	const [sizeCvv,setSizeCvv] = useState(3);
	const [progress, setProgress] = useState(0);
	const [typeNumCard, setTypeNumCard] = useState("");
	const [longCard, setLongCard] = useState(19);
	const [banco, setBanco] = useState("");
	const [cvvTemp, setCvvTemp] = useState("");
	const [maskAmex, setMaskAmex] = useState(false);
	const [tipoTarjetaPago,setTipoTarjetaPago] = useState("04");
	const handleChange = (event) => {
		handlePattern(event, typeNumCard);
		handleChanges(event,creditCardPago,errorForm,
			cvvTemp,{formatFchExpire,setCreditCardPago,
				setForm,setCvvTemp,setBanco});
	};
	const handleOpen = () => {
		setOpenModales({ ...openModales, modalCvv: true });
	};
	const handleCloseCvv = () => {
		const jsonPago = {
			monto: parseFloat(getDetallePago.monto).toFixed(2),
			numTarjeta: tarjetaTemp.replace(/ /g,""),
			mesExpiracion: creditCardPago.fchVencimiento.substring(0, 2),
			anioExpiracion: creditCardPago.fchVencimiento.substring(3, 5),
			cvv: cvvTemp,
			banco: banco.trim(),
			numReferencia: getDetallePago.referenciaBancaria,
			poliza: datosPagoDeducibleAuto.numPoliza,
			nombreTitular: creditCardPago.nombreTitular.trim(),
			isWeb: true,
			codSiniestro: datosPagoDeducibleAuto.codSiniestroPadre,
			numeroCliente: global.clienteUnico,
			correoElectronico: localStorage.getItem("correoSoyCliente"),
			tipoPago: tipoTarjetaPago
		}; 
		actionPagoBancario(jsonPago,action,creditCardPago,
			openModales,global.tid,{dispatch,setResponsePAgo,
				setOpenModales,setProgress,setCvvTemp,setDatosModal,setCreditCardPago});
	};

	const handleCloseDetalle = () => {
		setOpenModales({...openModales, modalDetalle: false,});
	};

	const iconCloseDetalle = () => {
		iconCloseDetalles(setOpenModales,openModales,dispatch,action);
	};

	const blurInput = (event) => {
		if (creditCardPago[event.target.name] !== "") {
			setForm({...errorForm, [event.target.name]: false,});
			erroresPago(event,{typeNumCard,sizeCvv,longCard,anoActual},creditCardPago, errorForm,{errorGenCard,setForm,errorFchVencimiento});
		}else{
			errorElseBlur(event,setForm,errorForm);
		}
	};

	const handleOptionCfdi = () => {
		handleOptionsCfdi({dispatch,setDatosModal,setOpenModales}, action,openModales,responsePago,dataSeguimiento,getDetallePago,global);
	};

	const handleCorreoNotificarComprobante = () => {
		handleCorreoNotificarComprobantes({dispatch,setDatosModal,setOpenModales,},action,global,responsePago,datosPagoDeducibleAuto,openModales);
	};

	const handleDescargaComprobante = () => {
		downloadPDF(responsePago.pdfComprobante, "ComprobantePagoDeducible.pdf");
	};

	const closeIconCvv = () => {
		closeIconCvvs(setOpenModales,setCreditCardPago,setForm,setCvvTemp,openModales,creditCardPago,errorForm);
	};

	const handleCloseErroresPago = () => {
		setOpenModales({...openModales, modalErroresPago: false,});
	};

	const handleCloseNotificacion = (event) => {
		handleCloseNotificaciones(event,setOpenModales,openModales,setDatosModal);
	};

	useEffect(() => {
		setPagoVentanilla(props.optionPago);
		setDatosPago({
			...datosPagoDeducibleAuto,
			codSiniestroPadre: props.pagoDeducibleAuto.codSiniestroPadre,
			codSiniestro: dataSeguimiento.codSiniestro,
			numPoliza: dataSeguimiento.numPoliza,
			tramoStatus: dataSeguimiento.estatus,
			totalPago: getDetallePago.monto,
			numReferencia: getDetallePago.referenciaBancaria,
		});
		setDatosReferenciaBancaria({
			nombreDocumento: props.datosReferenciaBancaria.nombreDocumento,
			urlVisualizacion: props.datosReferenciaBancaria.urlVisualizacion,
			base64: props.datosReferenciaBancaria.base64
		});
		dispatch(action.onLoading(false));
		return() => {
			dispatch(action.resetPagoLinea());
		};
	}, [props]);

	const receivePagoLinea = (json) => {
		setDataLinea({setCreditCardPago,setTarjetaTemp,setTipoTarjeta,
			setSizeCvv,setTypeNumCard,setLongCard,setBanco,
			setMaskAmex,setTipoTarjetaPago,setForm},creditCardPago,json,errorForm);
	};


	const disabledPagar = () => {
		return ( !disButPago.inpNombreTitular || !disButPago.inpNumTarjeta || !disButPago.inpBanco
			|| !disButPago.inpFchVencimiento || !disButPago.terminosCondiciones);
	};

	return (
		<div className="gnp-formas-pago" style={{ paddingTop: "24px", paddingBottom: "64px" }}>
			<Card className={pagoVentanilla === "linea" ? classes.cardPago : classes.cardPagoVentanilla}>
				<Grid container className={classes.inputStyles}>
					<Grid item xs={12} sm={12} md={8} lg={8} className={classes.borderGrid}>
						{regresar(setOpenModales,openModales)}
						{pagoVentanilla === "linea" ? 
							<PagoEnLinea dataPagoLinea={(json) => receivePagoLinea(json)}/> :
							<PagoVentanilla datosReferenciaBancaria={datosReferenciaBancaria}/>
						}
					</Grid>
					{detallesPago(datosPagoDeducibleAuto,classes,handleOpen,disabledPagar,pagoVentanilla)}
				</Grid>
				{modalProceso(openModales,classes,progress)}
				{modalCvv({classes,openModales,tipoTarjeta,banco,maskAmex,tarjetaTemp,longCard,errorForm,creditCardPago,sizeCvv},
					{handleCloseCvv,closeIconCvv,clickInput,errorCampoRequerido,blurInput,handleChange})}
				{modalDetalleRecibo({classes,openModales,datosPagoDeducibleAuto,responsePago},
					{handleCloseDetalle,iconCloseDetalle,handleOptionCfdi,handleCorreoNotificarComprobante,handleDescargaComprobante})}
				{modalNotificacionCorreo(openModales,datosModal,handleCloseNotificacion)}
				{modalErrorPago(openModales,datosModal,setOpenModales,handleCloseCvv)}
				{modalErroresPago(openModales,datosModal,handleCloseErroresPago)}
				{modalRegresar(openModales, setOpenModales,props)}
			</Card>
		</div>
	);
};
export default TipoPagoCfdi;




// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pago/pago.cmpt.js